import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "./firebase/index.js";

export interface AddSquareCustomerRequest {
  clientId: string;
  customerName: string;
  customerEmail?: string;
  customerPhone?: string;
  note?: string;
}

/**
 * Add a customer to the client's Square account.
 *
 * To enable for a new Square client:
 *   1. Add a named secret (e.g. ACME_SQUARE_ACCESS_TOKEN) to secrets.ts.
 *   2. Add the client entry to clientSquareConfig.ts referencing that secret.
 *   3. Add the secret to ALL_SQUARE_SECRETS in addSquareCustomer.ts.
 *   4. Call this function from the client app with that clientId.
 */
export async function addSquareCustomer(req: AddSquareCustomerRequest): Promise<void> {
  const fn = httpsCallable<AddSquareCustomerRequest, { success: boolean; customerId?: string }>(
    getFirebaseFunctions(),
    "addSquareCustomer",
  );
  await fn(req);
}
